import { connect } from "react-redux";
import SlateEditor from "../../shared/components/SlateEditor/editor";
import { useState } from "react";
import comment_ske_short from '../../../assets/images/svg/svg-funnel/comment-ske-short.svg';
import comment_ske from '../../../assets/images/svg/svg-funnel/comment-ske.svg';
import { postOnFeed } from "../../../store/action/postAction";

const PostEdit = (props) => {
  const { page, postOnFeed } = props;
  const [message, setMessage] = useState('');

  const handlePostOnFeed = () => {
    postOnFeed(message);
  }

  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v2-header-wrapper z-level-1 has-extra">
          <div className="app-v2-header-left">
            <div className="app-v2-breadcrumb-wrapper app-v2-header-breadcrumb">
              <span className="app-v2-header-breadcrumb-item">
                <span className="app-v2-breadcrumb-link">
                  <a aria-current="page" className="active" href="">
                    <span title="Danh sách bài viết">
                      Danh sách bài viết
                    </span>
                  </a>
                </span>
                <span className="app-v2-breadcrumb-separator">
                  <div className="svg-next-icon ic-breadcrumb-separator">
                  </div>
                </span>
              </span>
              <span className="app-v2-header-breadcrumb-item">
                <span className="app-v2-breadcrumb-link">
                  {/* <a href="" aria-current="page" className="active">
                    <span title="Siêu sale 11.11">
                      Siêu sale 11.11
                    </span>
                  </a> */}
                </span>
                <span className="app-v2-breadcrumb-separator">
                  <div className="svg-next-icon ic-breadcrumb-separator">
                  </div>
                </span>
              </span>
            </div>
          </div>
          <div className="app-v2-header-extra-wrapper">
            <div className="app-v2-header-extra-item">
              <div>
                {/* <button type="button" className="app-btn app-btn-default mr12">
                  Lưu nháp
                </button> */}
                <button type="button" className="app-btn app-btn-primary" onClick={handlePostOnFeed}>
                  Đăng bài
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="app-v2-layout-content">
          <div className="create-feed-main-body">
            <div className="create-feed-main-body-content">
              <div className="create-feed-main-body-title-input">
                <span>Chi tiết bài viết</span>
                <div>
                  <div className="input-text input-text-none-scrollbar text-multi none-background-color create-feed-main-body-input editor editor-2">
                    <SlateEditor
                      maxLength={5000}
                      valueDefault={message}
                      onChange={setMessage}
                    />
                  </div>
                </div>
              </div>
              <div className="create-feed-main-boder"></div>
              {/* <div className="create-feed-main-dynamic-tab-title"><span>Hình ảnh cho bài viết (1/4)</span></div> */}
              {/* <div className="create-feed-main-dynamic-tab-container"><span>Bạn có thể đăng tối đa 4 hình</span>
                <div className="mt10">
                  <div className="image-upload-inline display-flex">
                    <div className="display-flex">
                      <div className="ps-relative image-upload-inline-wrapper mr12"><img
                        className="image-upload-inline__item border-radius4"
                        src="" />
                        <div
                          className="image-upload-inline__item-remove pointer ps-absolute display-flex align-items-center justify-content-center">
                          <div className="svg-next-icon ic-multi">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div role="button" tabIndex="0" className="app-uploadfile--container app-uploadfile--select"><input
                      accept=".jpg, .jpeg, .jfif, .png,.webp, .svg, .bmp" multiple="" type="file" autoComplete="off"
                      tabIndex="-1" style={{ display: "none" }} /><button type="button"
                        className="app-btn app-btn-default image-upload-inline__button-default">
                        <div className="svg-next-icon ic-plus">
                        </div>
                        <div className="ml10 p-t1"><span>Thêm ảnh</span></div>
                      </button></div>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="create-feed-preview-container">
              <div className="preview-container">
                <div className="preview-container__screen">
                  <div className="preview-status-bar">
                    <div className="preview-status-bar__time"><span>05:43 CH</span></div>
                    <div className="preview-status-bar__energy">
                      <div className="svg-next-icon ic-phone-status">
                      </div>
                    </div>
                    <div className="preview-status-bar__white-block"></div>
                  </div>
                  <div className="preview-store-info">
                    <div className="preview-store-info__arrow-image">
                      <div className="svg-next-icon ic_back">
                      </div>
                    </div>
                    <div className="preview-store-info__avatar">
                      <span content="Ngày mới vui vẻ" className="app-avatar app-avatar-circle app-avatar-image" style={{ width: 26, height: 26, lineHeight: 26, background: "rgb(253, 189, 65)" }}>
                        <img src={page.page_avatar} /></span>
                    </div>
                    <div className="preview-store-info__container">
                      <div className="preview-store-info__container-name">
                        <span className="text-ellipsis">
                          {page.name}
                        </span>
                        <div className="svg-next-icon ic-fb-vertifed">
                        </div>
                      </div>
                      <div className="preview-store-info__container-name__sponsored"><span>Được tài trợ ·</span>
                        <div className="svg-next-icon ic-fb-public">
                        </div>
                      </div>
                    </div>
                    <div className="preview-store-info__menu-icon">
                      <div className="svg-next-icon ic-fb-menudot">
                      </div>
                    </div>
                  </div>
                  <div className="preview-container__body--no-footer">
                    <div className="preview-post-content-container">
                      <div className="preview-post-content-container-description">
                        <span className="">
                          {message}
                          {/* <span className="preview-post-content-container__view-more">
                            Xem thêm
                          </span> */}
                        </span>
                      </div>
                      <div className="preview-post-content-container-image">
                        <div className="multi-image-container ">
                          <div className="multi-image-second-container">
                            {/* <img className="multi-image-one-item" src="" /> */}
                          </div>
                          <div className="multi-image-second-container">
                            <div className="multi-image-second-image"></div>
                            <div className="multi-image-second-image"></div>
                            <div className="multi-image-second-image"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="preview-post-action-post-container line-height-18">
                      <div>
                        <div className="svg-next-icon mb2 ic-fb-like">
                        </div><span className="preview-post-action-post-container-btn">Thích</span>
                      </div>
                      <div>
                        <div className="svg-next-icon ic-fb-comment-post">
                        </div><span className="preview-post-action-post-container-btn">Bình luận</span>
                      </div>
                      <div>
                        <div className="svg-next-icon mb2 ic-fb-share">
                        </div>
                        <span className="preview-post-action-post-container-btn line-height-20">
                          Chia sẻ
                        </span>
                      </div>
                    </div>
                    <div className="preview-comment-ske-container">
                      <img src={comment_ske} />
                      <div className="preview-post-comment-ske-reply">
                        <img src={comment_ske_short} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="note-preview">
                <span>
                  Bố cục hình ảnh chỉ mang tính chất minh họa
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { page } = state;
  return {
    page
  };
};

export default connect(mapStateToProps, {
  postOnFeed
})(PostEdit);